import { generateCaptionCanvas } from '../components/artboard/utils'
import { SourceEditorCaption } from '../components/source-editor/types'
import { FPS } from '../constants'
import { CreationToolFrame } from '../types'
import CreationToolFont from '../types/font'
import CreationToolFontSize from '../types/font-size'

const convertSecondsIntoFrames = (seconds: number, fps: number): number => {
    return seconds * fps
}

type Props = {
    frames: CreationToolFrame[]
    captions: SourceEditorCaption[]
    fps?: number
    maxWidth: number
    cropX: number
    cropY: number
    cropHeight: number
}

export const drawCaptionsIntoFrames = ({ frames, captions, fps = FPS, maxWidth, cropX, cropY, cropHeight }: Props) => {
    return Promise.all(
        frames.map(async (frame, currentFrame) => {
            for (const caption of captions) {
                const {
                    start,
                    end,
                    text,
                    x,
                    y,
                    rotation,
                    style: { color, font, fontSize, strokeColor },
                } = caption

                let startFrame: number | undefined
                let endFrame: number | undefined

                startFrame = start && convertSecondsIntoFrames(start, fps)
                endFrame = end && convertSecondsIntoFrames(end, fps)

                if ((!startFrame && !endFrame) || (startFrame! <= currentFrame && endFrame! >= currentFrame)) {
                    const ctx = frame.canvas.getContext('2d')

                    if (ctx) {
                        const captionCanvas = await generateCaptionCanvas(
                            {
                                fontFamily: CreationToolFont.fontFamily(font),
                                fontSize:
                                    CreationToolFontSize.sizeBaseOnHeight(fontSize) *
                                    CreationToolFont.scale(font) *
                                    cropHeight,
                                fontWeight: CreationToolFont.fontWeight(font),
                                color,
                                strokeColor,
                                lineHeight: 1.3,
                                text: CreationToolFont.isAllCaps(font) ? text.toUpperCase() : text,
                            },
                            maxWidth
                        )
                        const width = captionCanvas.width
                        const height = captionCanvas.height
                        const frameWidth = width
                        const frameHeight = height

                        ctx.save()
                        ctx.translate(x - cropX, y - cropY)
                        ctx.rotate(rotation * (Math.PI / 180))

                        if (caption?.style.mirror) {
                            ctx.scale(-1, 1)
                        }

                        ctx.drawImage(captionCanvas, -frameWidth / 2, -frameHeight / 2)
                        ctx.restore()
                    }
                }
            }
        })
    )
}
